import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { createAgent, disableAgent, enableAgent, listAgents, patchAgent, type AgentBody } from '../api/agents';

export function useAgentList() {
  return useQuery({ queryKey: ['agents'], queryFn: listAgents, refetchOnWindowFocus: false });
}

function useInvalidateAgents() {
  const queryClient = useQueryClient();
  return () => void queryClient.invalidateQueries({ queryKey: ['agents'] });
}

export function useCreateAgent() {
  const invalidate = useInvalidateAgents();
  return useMutation({ mutationFn: (body: AgentBody) => createAgent(body), onSuccess: invalidate });
}

export function usePatchAgent() {
  const invalidate = useInvalidateAgents();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: Partial<AgentBody> }) => patchAgent(id, body),
    onSuccess: invalidate,
  });
}

export function useEnableAgent() {
  const invalidate = useInvalidateAgents();
  return useMutation({ mutationFn: (id: string) => enableAgent(id), onSuccess: invalidate });
}

export function useDisableAgent() {
  const invalidate = useInvalidateAgents();
  return useMutation({ mutationFn: (id: string) => disableAgent(id), onSuccess: invalidate });
}
